import "./App.scss";
import "../shared/style/index.scss";
import "react-toastify/dist/ReactToastify.css";
import React, { Component, Fragment } from "react";
import { ThemeProvider } from "@material-ui/styles";
import theme from "../shared/theme/Theme";
import { toast, ToastContainer } from "react-toastify";
import { Router } from "react-router-dom";
import browserHistory from "../services/browser-history";
import Routes from "../route/Routes";
import AccessDenied from "./AccessDenied";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { UserInfoService } from "../services/user-info.service";
import FormBuilderService from "../services/form-builder.service";
import { AccessToken } from "../utility/Constant";
import {
  consumeAuthRedirectPath,
  getCurrentAppPath,
  persistAuthRedirectPath,
} from "../services/auth-redirect.service";
import {
  signInWithRedirect,
  fetchAuthSession,
  getCurrentUser,
} from "aws-amplify/auth";
import { SessionManager } from "../services/session.manager";
import { logoutAndRedirect } from "../services/auth.service";

class App extends Component {
  constructor() {
    super();
    this.userInfoService = new UserInfoService();
    this.formBuilderService = new FormBuilderService();
    this.state = {
      userSSO: null,
      userRole: "",
      user: {},
      loading: true,
      accessDeniedError: null,
    };
    this.lastRoleCheckedTime = 0;
  }

  redirectToSignIn = async () => {
    persistAuthRedirectPath();
    await signInWithRedirect();
  };

  restorePendingRoute = () => {
    const redirectPath = consumeAuthRedirectPath();

    if (redirectPath && redirectPath !== getCurrentAppPath()) {
      browserHistory.replace(redirectPath);
    }
  };

  async silentAuth() {
    try {
      // Fetch the current session
      const session = await fetchAuthSession();

      // Extract tokens from session
      const accessToken = session.tokens?.accessToken?.toString();

      if (!accessToken) {
        await this.redirectToSignIn();
        return;
      }

      // Check if user is already logged in
      const user = await getCurrentUser();

      // Store tokens separately in localStorage
      localStorage.setItem("access_token", accessToken);
      this.restorePendingRoute();
      this.setState({
        loading: false,
      });
      let localRole = localStorage.getItem("user_role");
      const userRole =
        localRole && localRole.length > 0
          ? AccessToken.scope[localRole]
          : AccessToken.scope.TECHNICIAN;
      let PREFIX = "gesso_";
      let username = user.username;
      let decodedSSO = username.startsWith(PREFIX)
        ? username.substring(PREFIX.length)
        : username;
      localStorage.setItem("ge_sso", decodedSSO);
      this.userInfoService
        .getUserInfo(decodedSSO)
        .then((response) => {
          this.setState({
            userSSO: response,
            user: response,
            userRole: response.userRole,
            loading: false,
          });
        })
        .catch((error) => {
          console.error("Failed to fetch user info:", error?.message || error);
          if (error?.response?.status === 404) {
            this.setState({
              loading: false,
              accessDeniedError:
                error?.response?.data?.detail || "User not found",
            });
          } else {
            logoutAndRedirect();
          }
        });
    } catch (error) {
      console.error("Authentication failed:", error?.message || error);
      await this.redirectToSignIn();
    }
  }

  async componentDidMount() {
    this.silentAuth();

    // handling session management check when the user role is changed from "GLOBALADMIN" to "FORMAUTHOR"
    // window.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    const now = Date.now();
    const TEN_MINUTES = 10 * 60 * 1000;
    console.log("Time ==> " + (now - this.lastRoleCheckedTime));
    if (
      document.visibilityState === "visible" &&
      this.state.userSSO &&
      now - this.lastRoleCheckedTime > TEN_MINUTES
    ) {
      this.lastRoleCheckedTime = now;
      const currentUserSSO = localStorage.getItem("ge_sso");
      const userRole = localStorage.getItem("user_role");
      this.userInfoService.getUserInfo(currentUserSSO).then((response) => {
        if (response?.userRole && response?.userRole !== this.state.userRole) {
          this.setState({ userRole: response?.userRole, user: response });
          localStorage.setItem(
            "user_role",
            response.userRole ? response.userRole : "",
          );
          SessionManager.sharedInstance().updateCurrentUser(response);
        }
      });
    }
  };

  // componentWillUnmount() {
  //   window.removeEventListener("visibilitychange", this.handleVisibilityChange);
  // }

  render() {
    const { userSSO, loading, accessDeniedError } = this.state;

    if (accessDeniedError) {
      return (
        <ThemeProvider theme={theme}>
          <AccessDenied errorDetail={accessDeniedError} />
        </ThemeProvider>
      );
    }

    return (
      <Fragment>
        {userSSO && !loading && (
          <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Router history={browserHistory}>
                <Routes userRole={this.state.userRole} />
              </Router>
            </MuiPickersUtilsProvider>
            <ToastContainer
              enableMultiContainer
              hideProgressBar={true}
              position="bottom-center"
              draggable={false}
            />
            <ToastContainer
              enableMultiContainer
              containerId="formstore-container"
              position="top-center"
              hideProgressBar={true}
              draggable={false}
              className="formstore-toast-container"
            />
            <style>
              {`
                .formstore-toast-container.Toastify__toast-container--top-center {
                  top: 12em !important;
                  bottom: auto !important;
                  left: 40% !important;
                  transform: none !important;
                  width: 600px !important;
                  max-width: 90vw !important;
                }
                .formstore-toast {
                  width: 600px !important;
                  max-width: 90vw !important;
                  white-space: pre-wrap !important;
                  word-break: break-word !important;
                  text-align: center !important;
                  margin: 0 auto !important;
                }
              `}
            </style>
          </ThemeProvider>
        )}
      </Fragment>
    );
  }
}

export default App;
